// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
define(['lodash4', 'react', '/www/util/pub/pure_component.js',
    '/util/string.js', '/www/lum/pub/util/general.js',
    '/www/lum/pub/util/react.js', '/www/locale/pub/i18n_react.js',
    'classnames', '/www/util/pub/react.js', '/util/ajax.js',
    '/util/etask.js', '/www/lum/pub/util/recaptcha.js', '/util/storage.js',
    '/svc/compliance/pub/ext_util.js', '/util/escape.js',
    '/www/lum/pub/comp/ga.js', 'react-input-autosize',
    '/www/lum/pub/util/zmixpanel.js', '/www/lum/pub/uikit.input.js',
    '/www/lum/pub/uikit.js'],
    (_, React, Pure_component, string, general_util, react_util, i18n,
    classnames, util_react, ajax, etask, recaptcha, storage,
    compl_util, zescape, ga, Autosize,
    zmixpanel, {Dropdown: UIKitDropdown}, {Tooltip})=>
{
const {T} = i18n;
const {qw} = string;
const {with_label_tooltip} = react_util;
const {With_ref} = util_react;
const {with_ga} = ga;
const {assign} = Object;
const E = {};
class Input_comp extends Pure_component {
    constructor(props){
        super(props);
        _.bindAll(this, qw`on_change on_blur on_focus track`);
        this.state = {value_changed: false};
    }
    on_change(e){
        let {on_change, id, type} = this.props;
        let {value} = e.target;
        if (!on_change)
            return;
        this.setState({value_changed: true});
        if (type=='number' && value)
        {
            let {min='nope', max='nope'} = this.props;
            let parsed = parseFloat(value);
            if (min!='nope')
                parsed = Math.max(parsed, parseFloat(min));
            if (max!='nope')
                parsed = Math.min(parsed, parseFloat(max));
            value = ''+parsed;
        }
        on_change(value, id);
    }
    on_blur(e){
        const {value_changed} = this.state;
        if (value_changed)
        {
            this.track('changed');
            this.setState({value_changed: false});
        }
        let {on_blur, id} = this.props;
        if (!on_blur)
            return;
        on_blur(e.target.value, id);
    }
    on_focus(e){
        this.track('focused');
        let {on_focus, id} = this.props;
        if (!on_focus)
            return;
        on_focus(e.target.value, id);
    }
    track(evt_name){
        const {tracking} = this.props;
        if (!tracking || !tracking.name)
            return;
        zmixpanel.track(`${tracking.name} ${evt_name}`);
    }
    render(){
        let {id, type = 'text', value, icon, read_only, on_click, error,
            classes, style, input_classes, input_style, forwardedRef,
            on_icon_click, input_ref, medium, small, autosize, auto_focus,
            icon_size = 'regular', icon_placement = 'right', tooltip_message,
            on_key_down, button, on_button_click, ...rest} = this.props;
        let cond_classes = {with_icon: !!icon, clickable: !!on_click,
            error: !!error, medium: !!medium, small: !!small, autosize,
            [`ic_${icon_placement}`]: !!icon};
        let cname = general_util.get_classname('cp_input', input_classes,
            qw`with_icon clickable error medium small autosize large ic_right
              ic_left`, assign({}, rest, cond_classes));
        let wrapper_cname = general_util.get_classname('cp_input_wrapper',
            classes);
        let icon_sizes = qw`regular small tiny`.map(s=>`sz_${s}`);
        let icon_cname = general_util.get_classname('cp_input_icon', '',
            [icon, 'clickable', icon_placement, ...icon_sizes],
            {[icon]: 1, clickable: !!on_icon_click, [`sz_${icon_size}`]: 1,
            [icon_placement]: 1});
        let Tag = type=='textarea' ? 'textarea' :
            autosize ? Autosize : 'input';
        rest.onMouseEnter = this.ga_hook_fn(rest.onMouseEnter, 'input_hover');
        rest = _.omit(rest, qw`on_change use_infobox validate root_mark large
        label label_required on_blur`);
        return <Tooltip placement="bottom" tooltip={tooltip_message}>
            <div ref={forwardedRef} className={wrapper_cname} style={style}>
              <Tag id={id} className={cname} type={type} value={value}
                style={input_style} readOnly={!!read_only} ref={input_ref}
                onChange={this.ga_hook_fn(this.on_change, 'input_change')}
                onFocus={this.ga_hook_fn(this.on_focus, 'input_focus')}
                onClick={on_click||(()=>{})} onBlur={this.on_blur}
                onKeyDown={on_key_down} autoFocus={auto_focus} {...rest}/>
              {icon && <div className={icon_cname} onClick={on_icon_click}/>}
              {button && <button className="btn btn-default cp_input_button"
                onClick={on_button_click}>{button}</button>}
            </div>
        </Tooltip>;
    }
}
const Input = with_label_tooltip(With_ref(with_ga(Input_comp)));

// XXX antono: replace old component after migrating all imports
class UIKit_Dropdown_comp extends Pure_component {
    constructor(props){
        super(props);
        _.bindAll(this, qw`on_change on_click filter_option track`);
    }
    on_change(value){
        let {onChange, on_change, id} = this.props;
        onChange ? onChange(value) : on_change(value, id);
        this.track('changed', {value});
    }
    on_click(e){
        const {on_click} = this.props;
        this.track('clicked');
        if (!on_click)
            return;
        on_click(e);
    }
    track(evt_name, evt_props){
        const {tracking} = this.props;
        if (!tracking || !tracking.name)
            return;
        zmixpanel.track(`${tracking.name} ${evt_name}`, evt_props);
    }
    filter_option(option, filter){
        if (!filter || !option || this.props.creatable)
            return true;
        if (this.props.custom_filter)
            return this.props.custom_filter(option, filter);
        try {
            const regex = new RegExp(zescape.regex(filter), 'i');
            return option.data.group_header || regex.test(
                _.get(option.data.label_orig, 'props.children',
                    option.data.label_orig));
        } catch(e){
            return false;
        }
    }
    get options(){
        let opts = _.get(this.props, 'options', []);
        return opts.map(o=>{
            let label_orig = o.label_orig || o.label;
            let label_tooltip = <Tooltip tooltip={o.tooltip}
              placement={o.placement||'right'} noWrap>
              <span key={o.value}>
                {_.isString(o.label) ? <T>{o.label}</T> : o.label}
              </span>
            </Tooltip>;
            return {
                ...o,
                label: label_tooltip,
                label_orig,
                disabled: o.disabled,
            };
        });
    }
    option_renderer = opt=>opt.label_renderer||opt.label;
    render(){
        let {id, force_direction, error, clearable, value, classes='',
            on_hover, auto_focus=false,
            tooltip_message, icon, on_icon_click, icon_size='small', styles,
            icon_placement='left', 'data-qa': data_qa, ...rest} = this.props;
        let cn_opts = ['direction_'+force_direction,
            'with_icon', 'ic_left', 'ic_right'];
        let cls = general_util.get_classname('cp_dropdown', classes, cn_opts, {
            ['direction_'+force_direction]: !!force_direction,
            with_icon: !!icon,
            [`ic_${icon_placement}`]: !!icon,
        });
        let icon_sizes = qw`regular small tiny`.map(s=>`sz_${s}`);
        let icon_cname = general_util.get_classname('cp_dropdown_icon', '',
            [icon, 'clickable', icon_placement, ...icon_sizes],
            {[icon]: 1, clickable: !!on_icon_click, [`sz_${icon_size}`]: 1,
            [icon_placement]: 1});
        return <Tooltip placement="bottom" tooltip={tooltip_message}>
            <div className={cls} data-qa={data_qa}
              onMouseEnter={this.ga_hook_fn(on_hover, 'dropdown_hover')}
              onClick={this.ga_hook_fn(this.on_click, 'dropdown_click')}>
              {icon && <div className={icon_cname} onClick={on_icon_click}/>}
              <UIKitDropdown
                id={id}
                value={value}
                autoFocus={auto_focus}
                onChange={this.ga_hook_fn(this.on_change, 'dropdown_change')}
                filterOption={this.filter_option}
                {..._.omit(rest, 'label')}
                options={this.options}
                clearable={clearable}
                styles={{
                    control: baseStyles=>({
                        ...baseStyles,
                        ...error && {borderColor: '#f44336 !important'},
                    }),
                    ...styles,
                }}/>
            </div>
        </Tooltip>;
    }
}
const UIKit_Dropdown = with_label_tooltip(with_ga(UIKit_Dropdown_comp));

const country_options = _.map(compl_util.allowed_countries, (label, value)=>({
    label: <span className={'f19 '+value.toLowerCase()}>
          <span className={'flag '+value.toLowerCase()}/>
          <span>{`${value}: ${label}`}</span>
        </span>,
    value,
    label_orig: label,
}));
const Country_dropdown = props=>{
    let options = country_options;
    if (props.countries)
        options = options.filter(i=>props.countries.includes(i.value));
    if (props.autoselect)
    {
        options = [{value: '',
            label: <span className="cp_country_dropdown_autoselect">
              <span className="cp_country_dropdown_autoselect_icon"/>
              <span><T>{props.autoselect_label || 'Autoselect'}</T></span>
            </span>}, ...options];
    }
    let custom_filter = (option, filter)=>{
        filter = filter.toUpperCase();
        if (option.value.startsWith(filter))
            return true;
        let regex = new RegExp(zescape.regex(filter), 'i');
        return regex.test(option.data.label_orig);
    };
    return <UIKit_Dropdown {...props}
      classes={(props.classes||'')+' '+classnames('cp_country_dropdown')}
      options={options}
      clearable={props.clearable}
      custom_filter={custom_filter}
      virtualized
    />;
};

const user_form_submit = (form_id, data, opt)=>etask([function*(){
    return ajax.post(`/user_forms/submit`, assign({
        json: 1, content_type: 'application/json',
        no_throw: 1,
        data: JSON.stringify({form_id, data,
        falcon_id: window.lum_hs&&window.lum_hs.get_falcon_id(),
        ..._.fromPairs(qw`first_page_visited signup_referrer signup_page`.map(
            key=>[key, storage.get(key)])),
        recaptcha: yield recaptcha.new_token(form_id),
    })}, opt));
}]);
Object.assign(E, {Input, Country_dropdown, user_form_submit,
    country_options, UIKit_Dropdown});
return E; }); // eslint-disable-line
